module.exports = __webpack_public_path__ + "static/img/img-tuto02-01.bf0d4000.png";